import React from "react";
export interface BoxProps extends React.ComponentPropsWithRef<"div"> {
  as?: string;
}

const Box: React.FC<BoxProps> = ({ as, children, ...props }) => {
  const CustomTag = `${as}`;
  return <CustomTag {...props}>{children}</CustomTag>;
};

Box.defaultProps = {
  as: "div"
};

export { Box };
